export default __webpack_public_path__ + "static/media/circle.4cac0000.png";